{
  "ts": 1747207313,
  "tsCommit": 1747126943,
  "repoName": "NCApp3",
  "branchName": "prod",
  "rev": "f7fdb7e",
  "ver": "20250514_0721_NCApp3_prod_f7fdb7e",
  "env": "production",
  "appVer": "5.4.10",
  "isBranchDeployment": false,
  "e2eApiHostUrl": "https://api-master.naturalcycles.com"
}
